import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { AutoImage } from '../components/auto-image'
import { BannerImage } from '../components/banner-image'
import { BlogSection } from '../components/blog-section'
import { Mbr } from '../components/br'
import { ContentContainer } from '../components/content-container'
import { DecoratedFrame } from '../components/decorated-frame'
import { DesktopSnsIcons } from '../components/desktop-sns-icons'
import { Foldable } from '../components/foldable'
import { FqaSection } from '../components/fqa-section'
import { HeadBannar } from '../components/head-bannar'
import { HorizontalArticle, HorizontalArticleImageContainer, HorizontalArticleTextContainer, HorizontalArticleTitle, HorizontalArticleText } from '../components/horizontal-article'
import { ImageSection } from '../components/image-section'
import { KengakuFormSection } from '../components/kengaku-form-section'
import { MittuSection } from '../components/mittu-section'
import { MobileSnsIcons } from '../components/mobile-sns-icons'
import { PosterSection } from '../components/poster-section'
import { SaiyouSection } from '../components/saiyou-section'
import { ScheduleSection } from '../components/schedule-section'
import { Section } from '../components/section'
import { DiagramContainer, DiagramItem, ItemTitle, ItemText } from '../components/section-diagram'
import { SectionNavigator } from '../components/section-navigator'
import { SectionSpaceLarge, SectionSpaceMedium } from '../components/section-space'
import { SectionTextExtraLarge, SectionTextLarge, SectionTextMedium, SectionTextSmall } from '../components/section-text'
import { SectionTitle } from '../components/section-title'
import { SyukatsuSection } from '../components/syukatsu-section'
import { YoutubeSection } from '../components/youtube-section'
import SvgInterview001 from '../generated/svg/interview-001'
import SvgInterview002 from '../generated/svg/interview-002'
import SvgInterviewNavigateLabel001 from '../generated/svg/interview-navigate-label-001'
import SvgInterviewNavigateLabel002 from '../generated/svg/interview-navigate-label-002'
import SvgRecruitLabel01 from '../generated/svg/recruit-label-01'
import SvgRecruitLabel02 from '../generated/svg/recruit-label-02'
import SvgRecruitLabel03 from '../generated/svg/recruit-label-03'
import SvgRecruitLabel04 from '../generated/svg/recruit-label-04'
import SvgRecruitLabel05 from '../generated/svg/recruit-label-05'
import SvgRecruitLabel06 from '../generated/svg/recruit-label-06'
import SvgRecruitLabel07 from '../generated/svg/recruit-label-07'
import SvgRecruitLabel08 from '../generated/svg/recruit-label-08'
import SvgRecruitTitle01 from '../generated/svg/recruit-title-01'
import SvgRecruitTitle02 from '../generated/svg/recruit-title-02'
import SvgRecruitTitle03 from '../generated/svg/recruit-title-03'
import SvgRecruitTitle04 from '../generated/svg/recruit-title-04'
import SvgRecruitTitle05 from '../generated/svg/recruit-title-05'
import SvgRecruitTitle06 from '../generated/svg/recruit-title-06'
import SvgRecruitTitle07 from '../generated/svg/recruit-title-07'
import SvgRecruitTitle08 from '../generated/svg/recruit-title-08'
import SvgRecruitTitle09 from '../generated/svg/recruit-title-09'
import { useBreakpoint } from '../hooks/use-breakpoint'

const Outer = styled.div`
  --background-color: #f5e6ec;
  --nav-border: #96607a;
`

const Container = styled.div`
  width: 60rem;
  max-width: 100%;
  min-width: 0;
`

const Title = styled.div`
  font-size: 1.5rem;
  letter-spacing: 0.1em;
  margin-bottom: 1rem;
  line-height: 1.5;
  font-weight: 700;
  @media (max-width: 40rem){
    text-align: center;
  }
`

const Subtitle = styled.div`
  line-height: 1.5;
  font-weight: 700;
  font-size: 0.9rem;
`

const H2 = styled.div`
  color: #96607a;
  font-weight: 700;
  margin-bottom: 2rem;
`

const Text = styled.div`
  line-height: 2;
  font-size: 0.9rem;
`

const CommentContainer = styled.div`
  width: 60rem;
  max-width: 100%;
`

const CommentH2 = styled.div`
  font-weight: 700;
  margin-bottom: 2rem;
`

const Comment = styled.div`
  display: flex;
  font-size: 0.9rem;
  margin-left: 2rem;
  & + & {
    margin-top: 2rem;
  }
`

const CommentName = styled.div`
  flex: 0 0 3rem;
  line-height: 2;
`

const CommentText = styled.div`
  line-height: 2;
`

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100%;
  padding: 0 1rem;
  box-sizing: border-box;
  @media (max-width: 40rem){
    min-width: 0;
    max-width: 100vw;
  }
`

const NavigateLabel = styled.div`
  svg {
    display: block;
    height: 0.8rem;
    width: auto;
    max-width: 100%;
    margin: 0 auto;
  }
`

export const HeaderImageContainer = styled.div`
  position: relative;
  margin-bottom: 1rem;
  img {
    width: 100%;
  }
  @media (max-width: 40rem){
    margin-top: -3.5rem;
  }
`
const SnsIconContainer = styled.div`
  position: fixed;
  right: 1rem;
  transform: translateY(-230%);
  @media (max-width: 40rem){
    position: absolute;
    width: 100%;
    right: auto;
    transform: none;
    display: flex;
    top: 0;
    flex-direction: column;
    align-items: center;
  }
`

export const InterviewTitle = styled.div`
  margin: 0 auto;
  svg {
    display: block;
    height: 2.5rem;
    width: auto;
  }
`

const DecorationContainer = styled.div<{right?: boolean}>`
  height: 0;
  img {
    margin-left: auto;
    height: 6rem;
    width: auto;
    position: absolute;
    bottom: 0;
    left: 3rem;
    z-index: 0;
    @media (max-width: 40rem){
      height: 5rem;
      top: 0;
      right: 1rem;
      bottom: auto;
    }
  }
`

const BannerContainer = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
  justify-content: center;
  @media (max-width: 40rem){
    flex-direction: column;
  }
`

const BannerItem = styled.a`
  display: block;
  img {
    height: auto;
    width: 100%;
    max-width: 24rem;
  }
`

type RecruitPageProps = {

}
export const RecruitPage: FunctionComponent<RecruitPageProps> = () => {
  const isMobile = useBreakpoint('40rem')
  return <Outer>
  <HeaderImageContainer>
    <AutoImage src="/images/recruit_header.jpg" mobileSrc="/images/recruit_header_mobile.jpg" />

  </HeaderImageContainer>
  <ContentContainer>
    <SectionNavigator columns={2} labelMap={new Map([
      ['interview01', <NavigateLabel><SvgInterviewNavigateLabel001 /></NavigateLabel>],
      ['interview02', <NavigateLabel><SvgInterviewNavigateLabel002 /></NavigateLabel>],
    ])} />
    <SectionNavigator labelMap={new Map([
      ['miryoku', <NavigateLabel><SvgRecruitLabel01 /></NavigateLabel>],
      ['saiyou', <NavigateLabel><SvgRecruitLabel02 /></NavigateLabel>],
      ['schedule', <NavigateLabel><SvgRecruitLabel03 /></NavigateLabel>],
      ['image', <NavigateLabel><SvgRecruitLabel04 /></NavigateLabel>],
      ['youtube', <NavigateLabel><SvgRecruitLabel06 /></NavigateLabel>],
      ['syukatsu', <NavigateLabel><SvgRecruitLabel07 /></NavigateLabel>],
      ['fqa', <NavigateLabel><SvgRecruitLabel08 /></NavigateLabel>]
    ])} />
    <Section>
      <Inner>
        <SectionTextLarge letterSpacing="0.2em">
          なぜMURONOKIDSは学生に選ばれるのか？！
        </SectionTextLarge>
        <SectionTextMedium style={{fontWeight: '700', textAlign: 'left'}}>
          “子ども達の、そして日本の未来をデザインする施設”だからと思います。<br />
          私達はこう考えます、「子ども達の将来は日本の未来。<br />
          子どもの成長に大きく影響を与える私達の仕事は、大きな責任があると同時に、20年後の日本社会をデザインする意義深い仕事であるとも言えます。<br />
          ですから、職員には“誇りを持って” “楽しく”仕事に取り組んでほしい」と願っています。<br />
          MURONOKIDS（ムロノキッズ）では、政府が進める“働き方改革”に先駆けて、職員が働きやすい環境づくりに努めてきました。<br />
          ICT活用による業務効率化から始まり、風通しの良い職場づくり、知的好奇心をくすぐる環境設定など、そのチャレンジは多岐にわたります。<br />
          働く環境の改善・向上は今なお進行中で、この挑戦はまだまだ続いていくのです。多分（笑）…
        </SectionTextMedium>
      </Inner>
    </Section>
    <Section id="interview01">
      <Inner>
        <InterviewTitle><SvgInterview001 /></InterviewTitle>
        <SectionSpaceMedium />
        <DecoratedFrame leftTop="/images/deco_01.png" rightBottom="/images/deco_02.png">
          <AutoImage src="/images/recruit_img_01.jpg" mobileSrc="/images/recruit_img_01_mobile.jpg" />
        </DecoratedFrame>
        <SectionSpaceMedium />
        <Title>保育エバンジェリストとして<Mbr />採用の局面で自園の<Mbr />魅力を伝える伝道師</Title>
        <Subtitle>10年目職員　柴田彩（しばたあや）先生</Subtitle>
        <SectionSpaceLarge />

        <Container>
          <H2>【MURONOKIDSが学生に選ばれる理由】</H2>
          <Text>先生達の雰囲気の良さがいまMURONOKIDSが選ばれている理由だと考えています。平均年齢（平均年齢25歳）が若いので、同年代の職員が多く、園全体としていい意味で、みんな明るく学生さんを受け入れようという気持ちが表れています。みんなのびのびやっていて、相談事は先輩に聞くなど仕事がしやすい！と思われる雰囲気があります。</Text>
          <SectionSpaceMedium />
          <H2>【MURONOKIDSでの仕事を振り返ってみて】</H2>
          <Text>やはり節目節目で、よかったと思うことがあります。卒園児の弟妹のほとんどが入って来ていただける園なので、お兄ちゃん、お姉ちゃんが卒園児としての成長が見られるのです。私の場合、初始めの3年間は仕事に慣れるのに必死で、3年目に初めて担任を任せてもらったときに“幼稚園の先生はたいへんだ！”と思っしまいました。ただ、その大変さを乗り越えて4年目に担任をした時はとても楽しかったです。4～6年目は職場に慣れて、人間関係も安定したので、とても楽しい時期でしたね。8年目から職員室フリーをやっていますが、ここからステップが変わったように思います。裏方から全体の最適を考えて動き、保護者対応、事務仕事など、“縁の下の力持ち役”を担わせてもらっています（笑）。保護者との信頼関係は相手の感じ方もあるので、コロナによってストレスが溜まっている方へのケアなどの重要性がより分かるようになったので、もっと気を配って頑張っていきたいと思います。</Text>
        </Container>
        <SectionSpaceLarge />
        <DecoratedFrame>
          <AutoImage src="/images/recruit_img_02.jpg" mobileSrc="/images/recruit_img_02_mobile.jpg" />
        </DecoratedFrame>
        <SectionSpaceLarge />
        <Container>
          <H2>【MURONOKIDSが学生に選ばれる理由】</H2>
          <Text>
            １．先生達が明るい！雰囲気がいい<br />
            ２．大きな畑がある<br />
            ３．設備が整っている！<br />
            特にICT環境が整っているので、私もPCの操作が得意になってしまいました！もともと苦手意識があったわけではないですが、今はもうエキスパートレベル（笑）になりました。「連絡アプリ」を導入しているので、保護者とのやり取りや日誌等もその専用のアプリで出来るので、手書き作業、電話対応が激減しました。ZOOMで個人面談をしたり、プリスクールもオンラインで懇談会をするので、圧倒的に業務量が減りました。ITスキルは個人差はありますが、コロナ禍で動画編集などが出来るようになった人はとても増えました。初めやり方を覚えるまではやっぱり大変なところもありましたけど、数をこなせば出来るようになる。
          </Text>
          <SectionSpaceMedium />
          <H2>【就職後に努力したことについて】</H2>
          <Text>いろいろあるけど思い浮かばない。。。健康には気を付けている。担任するにあたって休んではいけないという気持ちがあったので！特別なことはしていないので、人込みを避ける、手洗い、うがいをきちんとするなど、当たり前のことを当たり前に出来るようにした。胃腸炎になり易かったので、ならないように！と念じていたところ、いつのころからか胃腸炎にならなくなりました（笑）。知識を蓄えるために、ニュースをよく見るようになりましたし、大人になっている実感があります（笑笑）。</Text>
        </Container>
        <SectionSpaceLarge />
      </Inner>
    </Section>
    <Section id="interview02">
      <Inner>
        <InterviewTitle><SvgInterview002 /></InterviewTitle>
        <SectionSpaceMedium />
        <DecoratedFrame leftTop="/images/deco_01.png" rightBottom="/images/deco_02.png">
          <AutoImage src="/images/recruit_img_03.jpg" mobileSrc="/images/recruit_img_03_mobile.jpg" />
        </DecoratedFrame>
        <SectionSpaceLarge />
        <SectionSpaceMedium />
        <HorizontalArticle>
          <HorizontalArticleImageContainer>
            <AutoImage src="/images/recruit_img_04.jpg" mobileSrc="/images/recruit_img_04_mobile.jpg" />
          </HorizontalArticleImageContainer>
          <HorizontalArticleTextContainer>
            <HorizontalArticleTitle>
              3年目職員
            </HorizontalArticleTitle>
            <HorizontalArticleTitle>
              津田晴奈<small>（つだはるな）</small>
            </HorizontalArticleTitle>
            <HorizontalArticleText>
              出身地：神奈川県厚木市<br />
              好きな食べ物：エビフライ<br />
              嫌いな食べ物：野菜、ちなみにナスは絶対に食べられない！
            </HorizontalArticleText>
            <DecorationContainer>
              <AutoImage src="/images/deco_03.png"/>
            </DecorationContainer>
          </HorizontalArticleTextContainer>
        </HorizontalArticle>
        <SectionSpaceLarge />
        <HorizontalArticle>
          <HorizontalArticleTextContainer>
            <HorizontalArticleTitle>
              3年目職員
            </HorizontalArticleTitle>
            <HorizontalArticleTitle>
              木曽めい<small>（きそめい）</small>
            </HorizontalArticleTitle>
            <HorizontalArticleText>
              出身地：神奈川県鎌倉市<br />
              好きな食べ物：お寿司（特にサーモン、ホタテ、そして鯛<br />
              嫌いな食べ物：ない！（言っていたが、インタビューの最後に“いくら”を食べすぎて嫌いになったとトロ？）
            </HorizontalArticleText>
            <DecorationContainer right>
              <AutoImage src="/images/deco_04.png"/>
            </DecorationContainer>
          </HorizontalArticleTextContainer>
          <HorizontalArticleImageContainer>
            <AutoImage src="/images/recruit_img_05.jpg" mobileSrc="/images/recruit_img_05_mobile.jpg" />
          </HorizontalArticleImageContainer>
        </HorizontalArticle>
        <SectionSpaceLarge />
        <HorizontalArticle>
          <HorizontalArticleImageContainer>
            <AutoImage src="/images/recruit_img_06.jpg" mobileSrc="/images/recruit_img_06_mobile.jpg" />
          </HorizontalArticleImageContainer>
          <HorizontalArticleTextContainer>
            <HorizontalArticleTitle>
              3年目職員
            </HorizontalArticleTitle>
            <HorizontalArticleTitle>
              関根風華<small>（せきねふうか）</small>
            </HorizontalArticleTitle>
            <HorizontalArticleText>
              出身地：三重県→横浜<br />
              好きな食べ物：パスタ（1位ビアンコ、2位納豆、3位ナポリタン<br />
              嫌い食べ物：なんと肉全般
            </HorizontalArticleText>
            <DecorationContainer>
              <AutoImage src="/images/deco_05.png"/>
            </DecorationContainer>
          </HorizontalArticleTextContainer>
        </HorizontalArticle>
        <SectionSpaceLarge />
        <CommentContainer>
          <CommentH2>
            【MURONOKIDSを選んだ理由】
          </CommentH2>
          <Comment>
            <CommentName style={{color: '#a1d6d3'}}>木曽</CommentName>
            <CommentText>まず、先輩達が若くてとても働きやすい職場と印象でした。職場の人間関係を重視して就職先を選んでいた私にとってはとても惹かれる職場でした。</CommentText>
          </Comment>
          <Comment>
            <CommentName style={{color: '#f2a7b3'}}>津田</CommentName>
            <CommentText>私もまったく同じです！</CommentText>
          </Comment>
          <Comment>
            <CommentName style={{color: '#fcd24d'}}>関根</CommentName>
            <CommentText>私も同じなのなんですが、もうひとつ保育園と幼稚園で悩んでいたところ、柴田先生に声を掛けられて、雰囲気がとても良かったので就職を決めました。</CommentText>
          </Comment>
        </CommentContainer>
        <SectionSpaceLarge />
        <DecoratedFrame>
          <AutoImage src="/images/recruit_img_07.jpg" mobileSrc="/images/recruit_img_07_mobile.jpg" />
        </DecoratedFrame>
        <SectionSpaceLarge />
        <CommentContainer>
          <CommentH2>
            【MURONOKIDSで働いて良かった事】
          </CommentH2>
          <Comment>
            <CommentName style={{color: '#fcd24d'}}>関根</CommentName>
            <CommentText>同期が多いので、助けてもらったり、助けたりすることができています！ピアノは楽譜も読めないくらい苦手でしたが、ここでもやはり同期の存在があって、鼓舞されて乗り越えられています！</CommentText>
          </Comment>
          <Comment>
            <CommentName style={{color: '#f2a7b3'}}>津田</CommentName>
            <CommentText>同期はもちろんですが、幼稚園と保育園があるし、小学生も来ているので、子どもの成長と長くかかわれるのがとても魅力の園です。</CommentText>
          </Comment>
          <Comment>
            <CommentName style={{color: '#a1d6d3'}}>木曽</CommentName>
            <CommentText>同期もそうですが、職場の平均年齢が若いので、先輩とも仲良く出来るのがとてもいいです。“オン”と“オフ”がはっきりしているので、とてもメリハリのある職場というのも魅力です。</CommentText>
          </Comment>
        </CommentContainer>
        <SectionSpaceLarge />
        <DecoratedFrame>
          <AutoImage src="/images/recruit_img_08.jpg" mobileSrc="/images/recruit_img_08_mobile.jpg" />
        </DecoratedFrame>
        <SectionSpaceLarge />
        <CommentContainer>
          <CommentH2>
            【MURONOKIDSのいいところ3選】
          </CommentH2>
          <Comment>
            <CommentName style={{color: '#f2a7b3'}}>津田</CommentName>
            <CommentText>
              •	家賃補助<br />
              •	行事<br />
              •	幼稚園の担任をやりたかったので、幼稚園で働けること！<br />
              ちなみに私は家賃補助を活用させてもらい、一人暮らしをしていますが、得意料理は、野菜炒め！なんです。（野菜嫌いなのに…ｗ）
            </CommentText>
          </Comment>
          <Comment>
            <CommentName style={{color: '#fcd24d'}}>関根</CommentName>
            <CommentText>
              •	子どもが明るい<br />
              •	先輩が優しい<br />
              •	行事が多い！<br />
              好きな行事は、生活発表会です。教えるのは大変だったけど、真ん中で見ていると子ども供の成長を間近で感じられて感動しますし、達成感があります！
            </CommentText>
          </Comment>
          <Comment>
            <CommentName style={{color: '#a1d6d3'}}>木曽</CommentName>
            <CommentText>
              •	横浜市にある！ <br />
              •	行事が多い！<br />
              •	制服がある！<br />
              制服（職員のユニフォーム）はいいです。おしゃれだし。ここ（ムロノキッズ）ではすべて決まっているので、統一感があっていい！そしてなんといっても、横浜駅で15分なんて！一曲聞いてたら終わりじゃないですか。とても住みやすいし、最高です！ 
            </CommentText>
          </Comment>
        </CommentContainer>
        <SectionSpaceLarge />
        <DecoratedFrame>
          <AutoImage src="/images/recruit_img_09.jpg" mobileSrc="/images/recruit_img_09_mobile.jpg" />
        </DecoratedFrame>
        <SectionSpaceLarge />
        <CommentContainer>
          <CommentH2>
            【就職後に努力したことについて】
          </CommentH2>
          <Comment>
            <CommentName style={{color: '#f2a7b3'}}>津田</CommentName>
            <CommentText>
              仕事を持ち帰らないことと自炊です。自炊は、本当に親のありがたみがメチャクチャわかるようになりました。ｗ
            </CommentText>
          </Comment>
          <Comment>
            <CommentName style={{color: '#fcd24d'}}>関根</CommentName>
            <CommentText>
              ピアノの練習をひそかにしています。家にピアノがあるのでそれで練習している！と言っても、消音にして、9時以降は引かないようにしていますけど。
            </CommentText>
          </Comment>
          <Comment>
            <CommentName style={{color: '#a1d6d3'}}>木曽</CommentName>
            <CommentText>
              季節の変わり目で私は絶対に風邪ひくので、体調管理に気を使っています。コロナ禍というのもあって、今休めない状況ですし、もし休んだら子どもに心配かけるので、休まないように、早寝早起きを心がけすぎています。日曜の夜なんて、イッテＱ見ながら布団に入ります。風邪ひいてなさすぎるので、「自分やってるな！」という実感を持っています。
            </CommentText>
          </Comment>
        </CommentContainer>
        <SectionSpaceLarge />
        <Foldable
          color="#00b2cc"
          header={
            <InterviewTitle id="miryoku">
              <SvgRecruitTitle01 />
            </InterviewTitle>
          }
        >
          <MittuSection />
        </Foldable>
        <Foldable
          color="#9d92c1"
          header={
            <InterviewTitle id="saiyou">
              <SvgRecruitTitle02 />
            </InterviewTitle>
          }
        >
          <SaiyouSection />
        </Foldable>
        <Foldable
          color="#9d92c1"
          header={
            <InterviewTitle id="schedule">
              <SvgRecruitTitle03 />
            </InterviewTitle>
          }
        >
          <ScheduleSection />
        </Foldable>
        <Foldable
          color="#9d92c1"
          header={
            <InterviewTitle id="image">
              <SvgRecruitTitle04 />
            </InterviewTitle>
          }
        >
          <ImageSection />
        </Foldable>
        <Foldable
          color="#eea76e"
          header={
            <InterviewTitle id="youtube">
              <SvgRecruitTitle06 />
            </InterviewTitle>
          }
        >
          <YoutubeSection />
        </Foldable>
        <Foldable
          color="#00b2cc"
          header={
            <InterviewTitle id="syukatsu">
              <SvgRecruitTitle07 />
            </InterviewTitle>
          }
        >
          <SyukatsuSection />
        </Foldable>
        <Foldable
          color="#9d92c1"
          header={
            <InterviewTitle id="fqa">
              <SvgRecruitTitle08 />
            </InterviewTitle>
          }
        >
          <FqaSection />
        </Foldable>
        <Foldable
          color="#a6ca5e"
          header={
            <InterviewTitle id="mousikomi">
              <SvgRecruitTitle09 />
            </InterviewTitle>
          }
        >
          <KengakuFormSection />
        </Foldable>
        <SectionSpaceLarge />
      </Inner>
    </Section>
    <BannerContainer>
      <BannerItem href="https://kkodomoen.com/">
        <AutoImage src="/images/bnr_02.jpg"></AutoImage>
      </BannerItem>
    </BannerContainer>
  </ContentContainer>
  </Outer>
}